import { render, staticRenderFns } from "./freeOrder.vue?vue&type=template&id=c1288850&scoped=true"
import script from "./freeOrder.vue?vue&type=script&lang=js"
export * from "./freeOrder.vue?vue&type=script&lang=js"
import style0 from "./freeOrder.vue?vue&type=style&index=0&id=c1288850&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1288850",
  null
  
)

export default component.exports